import React from 'react'
import { render } from 'react-dom'
import { Router, Route } from 'react-router'
import { Provider } from 'react-redux'
import TagManager from 'react-gtm-module'

import store, { history } from './store'
import EditorPage from './containers/EditorPage/EditorPage'
import MobileEditorPage from './containers/MobileEditorPage/MobileEditorPage'
import PresentationPage from './containers/PresentationPage/PresentationPage'
import PresentationControllerPage from './containers/PresentationControllerPage/PresentationControllerPage'
import SignupPage from './containers/SignupPage/SignupPage'
import PaymentCompletePage from './containers/PaymentCompletePage/PaymentCompletePage'
import PaymentCheckoutPage from './containers/PaymentCheckoutPage/PaymentCheckoutPage'
import LoginPage from './containers/LoginPage/LoginPage'
import PasswordResetPage from './containers/PasswordResetPage/PasswordResetPage'
import WithdrawPage from './containers/WithdrawPage/WithdrawPage'
import InputEmailForPasswordResetPage from './containers/InputEmailForPasswordResetPage/InputEmailForPasswordResetPage'
import SplitSpPcComponent from './components/organisms/SplitSpPcComponent/SplitSpPcComponent'
import '../commons/css/reset.css'
import ErrorBoundary from './components/organisms/ErrorBoundary/ErrorBoundary'

const tagManagerArgs = {
  gtmId: 'GTM-KFNR6KW'
}

TagManager.initialize(tagManagerArgs)

render(
  <ErrorBoundary>
    <Provider store={store}>
      <Router
        history={history}
        onUpadate={() => {
          window.scrollTo(0, 0)
        }}
      >
        <Route path="/" component={SplitSpPcComponent(MobileEditorPage, EditorPage)} />
        <Route path="/presentation" component={PresentationPage} />
        <Route path="/controller" component={PresentationControllerPage} />
        <Route path="/signup" component={SignupPage} />
        <Route path="/login" component={LoginPage} />
        <Route path="/payment" component={PaymentCheckoutPage} />
        <Route path="/payment/complete" component={PaymentCompletePage} />
        <Route path="/password_reset/email" component={InputEmailForPasswordResetPage} />
        <Route path="/password_reset" component={PasswordResetPage} />
        <Route path="/withdraw" component={WithdrawPage} />
      </Router>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('app')
)
